<template>
  <v-container
    class="product-slider"
    v-if="mode === 'banner' || (products && products.length > 0)"
  >
    <div class="d-flex justify-center" v-if="title">
      <h2 v-html="title"></h2>
    </div>
    <div v-intersect.once="handleView">
      <ProposalImage v-if="mode == 'banner' && hasImage" :proposal="proposal" />
      <swiper
        :options="swiperOption"
        ref="swiperRef"
        v-if="products.length > 0"
      >
        <swiper-slide v-for="product in products" :key="product.productId">
          <ProductCard v-bind:product="product" :position="position" />
        </swiper-slide>
      </swiper>
    </div>
    <div
      class="swiper-pagination"
      :class="paginationClass"
      slot="pagination"
      v-if="products.length > 1"
    ></div>
  </v-container>
</template>
<style global lang="scss">
.product-slider {
  position: relative;
  // .swiper-wrapper {
  //   padding: 20px 0px;
  // }
  .proposal-img {
    margin-bottom: 10px;
  }
  .banner-card {
    width: 100%;
    margin-bottom: 20px;
  }
  .proposal-card {
    //width: 220px;
    height: 365px;
    .v-card__text {
      width: auto;
    }
    img {
      padding: 0px;
      align-self: center;
    }
  }
}
</style>
<script>
import ProductService from "~/service/productService";
import ProductCard from "@/components/product/ProductCard";
import ProposalImage from "@/components/proposal/ProposalImage";

import analyticsService from "~/service/analyticsService";

import get from "lodash/get";

export default {
  name: "ProductListSlider",
  props: {
    productList: { type: Array, required: false },
    proposal: { type: Object, required: false },
    layout: { type: Number, required: false },
    categoryId: { type: Number, required: false },
    productId: { type: Number, required: false },
    shuffle: { type: Boolean, required: false, default: false },
    promo: { type: Boolean, required: false, default: false },
    limit: { type: Number, required: false, default: 8 },
    title: { type: String, required: false },
    paginationClass: { type: String, required: false },
    position: { type: String, required: false }
  },
  components: { ProductCard, ProposalImage },
  data() {
    return {
      products: [],
      swiperOption: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        watchOverflow: true,
        pagination: {
          el: "." + this.paginationClass,
          clickable: true
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            centeredSlides: true
          },
          600: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            centeredSlides: true
          },
          960: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            centeredSlides: false
          },
          1280: {
            slidesPerView: 4,
            slidesPerGroup: 3,
            centeredSlides: false
          },
          1590: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            centeredSlides: false
          }
        }
      }
    };
  },
  async mounted() {
    if (this.mode == "card") {
      await this.fetchProducts();
    }
  },
  computed: {
    hasImage() {
      return this.proposal && this.proposal.img != "https://grosmarket.it";
    },
    mode() {
      return get(this.proposal, "metaData.category_proposal_type.MODE", "card");
    }
  },
  methods: {
    async fetchProducts() {
      if (this.productList) {
        this.products = this.productList;
      } else if (this.proposal) {
        let response = await ProductService.search({
          parent_category_id: this.proposal.categoryProposedId,
          page_size: 12
        });
        this.products = response.products;
      } else {
        let response = await ProductService.adv({
          layout: this.layout,
          product_id: this.productId,
          category_id: this.categoryId,
          limit: this.limit,
          shuffle: this.shuffle,
          promo: this.promo
        });
        this.products = response.products;
      }
    },
    handleView(entries, observer, isIntersecting) {
      if (isIntersecting && this.products.length > 0) {
        analyticsService.viewProducts(this.products, this.position);
      }
    }
  }
};
</script>
